import React, { useContext, useEffect } from "react";
import "./Settings.scss";
import GATracker from "../components/GATracker";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Switch, Route, NavLink } from "react-router-dom";
import { Sliders } from "react-bootstrap-icons";

import { UserContext } from "../../api/user/userContext";
import { LoadingContext } from "../../api/loading/LoadingContext";
import SettingsInfos from "./SettingsInfos";
import SettingsDisplay from "./SettingsDisplay";

const LoadingAnimation = require("react-loading-animation");

function Settings({ onLogin }) {
  const { user, dispatchUser } = useContext(UserContext);
  const { loading, dispatchLoading } = useContext(LoadingContext);

  const { t } = useTranslation();

  useEffect(() => {
    if (loading.progress !== 100) {
      dispatchLoading({ type: "update", payload: 100 });
    }
    return () => {
      //console.log("settings done");
    };
  }, [user, dispatchUser, loading, dispatchLoading]);

  return (
    <>
      <GATracker></GATracker>

      <PerfectScrollbar className="settings-scroll main-scroll">
        <div className="settings-container d-flex flex-column">
          <header>
            <Sliders />
            {t("navigation.settings")}
          </header>
          {user !== null && loading.progress === 100 ? (
            <div className="settings-tabs-container d-flex flex-column">
              <Navbar className="settings-tabs">
                <NavLink to={"/settings/infos"}>
                  <span>{t("settings.infos")}</span>
                </NavLink>
                <NavLink to={"/settings/display"}>
                  <span>{t("settings.display")}</span>
                </NavLink>
              </Navbar>
            </div>
          ) : (
            <div className="loading-container">
              <LoadingAnimation />
            </div>
          )}
        </div>
        <div className="settings-details-container d-flex flex-column">
          {user !== null ? (
            <>
              {loading.progress === 100 ? (
                <Switch>
                  <Route
                    path="/settings/infos"
                    render={(props) => (
                      <SettingsInfos
                        {...props}
                        onLogin={onLogin}
                      ></SettingsInfos>
                    )}
                  />
                  <Route
                    path="/settings/display"
                    render={(props) => (
                      <SettingsDisplay
                        {...props}
                        onLogin={onLogin}
                      ></SettingsDisplay>
                    )}
                    onLogin={onLogin}
                  />
                </Switch>
              ) : (
                <div className="loading-container">
                  <LoadingAnimation />
                </div>
              )}
            </>
          ) : (
            <div className="loading-container">
              <LoadingAnimation />
            </div>
          )}
        </div>
      </PerfectScrollbar>
    </>
  );
}

export default Settings;
